<template>
  <v-home-slide
    :loading="loading"
  >
    <div
      v-if="hasData"
      class="h-full w-full"
    >
      <calculation-row
        :calculations="calculations"
      />

      <gdt-row
        :gdt="gdt"
      />
    </div>
  </v-home-slide>
</template>

<script>
import CalculationRow from '@/views/Home/Valorization/Calculations/CalculationRow';
import GdtRow from '@/views/Home/Valorization/Gdt/GdtRow';
import {LoadsDataMixin} from '@/mixins/LoadsDataMixin';

export default {
  name: 'Valorization',
  components: {
    CalculationRow,
    GdtRow,
  },
  mixins: [
    LoadsDataMixin,
  ],
  data() {
    return {
      calculations: {},
      gdt: {},
    };
  },
  computed: {
    hasData() {
      return Object.keys(this.calculations).length > 0
          && Object.keys(this.gdt).length > 0;
    },
  },
  methods: {
    async loadData() {
      const { data } = await this.$api.get('valorization').get(this.createCancelTokenOption());

      this.calculations = data.calculations;
      this.gdt = data.gdt;
    },
  },
};
</script>
